export const sagaActions = {
  FETCH_STUDENT_DATA: "FETCH_STUDENT_DATA",
  UPDATE_STUDENT_STATUS: "UPDATE_STUDENT_STATUS",
  FETCH_ALUMNI_DATA: "FETCH_ALUMNI_DATA",
  UPDATE_ALUMNI_STATUS: "UPDATE_ALUMNI_STATUS",
  FETCH_OPTION_DATA: "FETCH_OPTION_DATA",
  UPDATE_ALUMNI_TICKET_STATUS: "UPDATE_ALUMNI_TICKET_STATUS",
};